"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("@/react/pages/qc/base/{utils}/constants");
const axios_1 = __importDefault(require("axios"));
const client_1 = require("react-dom/client");
const Threads_1 = __importDefault(require("@/react/components/Threads"));
const zustand_1 = require("zustand");
const immer_1 = require("zustand/middleware/immer");
const immer_2 = require("immer");
const utils_1 = require("@/react/components/Threads/utils");
const pusher_js_1 = __importDefault(require("pusher-js"));
const NotificationToast_1 = require("@/react/components/Threads/NotificationToast");
(0, immer_2.enableMapSet)();
const react_1 = __importDefault(require("react"));
class Topics {
    static TOPICS_PUSHER_INSTANCE = null;
    static TOPICS_USER_NOTIFICATIONS_CHANNEL = null;
    namespace;
    sourceUrl;
    canManageThreads = false;
    isNamespaceAdmin = false;
    currentUser;
    API_CLIENT;
    panelContainer;
    panelTrigger;
    initialThreadId;
    topicStores = [];
    dataStore = (0, zustand_1.createStore)((0, immer_1.immer)(set => ({
        threads: new Map(),
        comments: new Map(),
        setThreads: (threads) => set(s => {
            threads.forEach(t => {
                s.threads.set(t.id, t);
            });
        }),
        setComments: (comments) => set(s => {
            comments.forEach(c => {
                s.comments.set(c.id, c);
            });
        }),
    })));
    panelStore = this.create_topic_store('panel');
    floatingStore = this.create_topic_store('floating');
    static SHAPES = {
        TRIANGLE: 'top-right-triangle',
    };
    onCheck = () => true;
    onTravel = async () => { };
    threadActions = {
        created: d => this.addThreadWithCommentToStore(d),
        updated: d => this.updateThreadInStore(d),
        deleted: d => this.deleteThreadFromStore(Number(d.id)),
        deleted_all: d => this.deleteAllThreadsFromStore(Boolean(d.is_resolved)),
    };
    commentActions = {
        created: d => {
            if (d.parent_comment_id) {
                this.postReplyToComment(d.parent_comment_id, d);
            }
            else {
                this.addThreadComment(d.thread_id, d);
            }
        },
        updated: d => this.updateCommentInStore(d.id, d),
        deleted: d => this.deleteCommentFromStore(d.id),
    };
    create_topic_store(key) {
        const obj = (set) => ({
            threadIds: new Set(),
            commentIds: new Set(),
            replyIds: new Set(),
            mapSurfacedCommentIds: new Map(),
            mapThreadToComments: new Map(),
            mapCommentToReplies: new Map(),
            setThreadIds: (ids) => set(state => {
                state.threadIds = new Set(ids);
            }),
            addThreadIds: (ids) => set(state => {
                ids.forEach(id => state.threadIds.add(id));
            }),
            deleteThreadIds: (ids) => set(state => {
                ids.forEach(id => state.threadIds.delete(id));
            }),
            setCommentIds: (ids) => set(state => {
                state.commentIds = new Set(ids);
            }),
            addCommentIds: (ids) => set(state => {
                ids.forEach(id => state.commentIds.add(id));
            }),
            deleteCommentIds: (ids) => set(state => {
                ids.forEach(id => state.commentIds.delete(id));
            }),
            setReplyIds: (ids) => set(state => {
                state.replyIds = new Set(ids);
            }),
            addReplyIds: (ids) => set(state => {
                ids.forEach(id => state.replyIds.add(id));
            }),
            deleteReplyIds: (ids) => set(state => {
                ids.forEach(id => state.replyIds.delete(id));
            }),
            addMapThreadToComments: (threadId, commentIds) => set(state => {
                const existing = state.mapThreadToComments.get(threadId) || new Set();
                commentIds.forEach(id => existing.add(id));
                state.mapThreadToComments.set(threadId, existing);
            }),
            removeMapThreadToComments: (threadId) => set(state => {
                state.mapThreadToComments.delete(threadId);
            }),
            addMapCommentToReplies: (commentId, replyIds) => set(state => {
                const existing = state.mapCommentToReplies.get(commentId) || new Set();
                replyIds.forEach(id => existing.add(id));
                state.mapCommentToReplies.set(commentId, existing);
            }),
            removeMapCommentToReplies: (commentId) => set(state => {
                state.mapCommentToReplies.delete(commentId);
            }),
            addSurfacedCommentIds: (parentCommentId, ids) => set(state => {
                const existing = state.mapSurfacedCommentIds.get(parentCommentId) || new Set();
                ids.forEach(id => existing.add(id));
                state.mapSurfacedCommentIds.set(parentCommentId, existing);
            }),
            removeSurfacedCommentIds: (parentCommentId) => set(state => {
                state.mapSurfacedCommentIds.delete(parentCommentId);
            }),
            clearSurfaceCommentIds: () => set(state => {
                state.mapSurfacedCommentIds.clear();
            }),
        });
        const store = (0, zustand_1.createStore)((0, immer_1.immer)(set => obj(set)));
        this.topicStores.push({ store, key });
        return store;
    }
    get_thread_from_data(threadData) {
        return {
            id: threadData.id,
            isResolved: threadData.is_resolved === 1,
            isPinned: threadData.is_pinned === 1,
            selector: threadData.selector,
            title: threadData.title,
            createdAt: threadData.created_at,
            url: threadData.url,
            userId: threadData.user_id,
        };
    }
    get_comment_from_data(commentData) {
        return {
            id: commentData.id,
            isDeleted: commentData.soft_delete === 1,
            isEdited: commentData.is_edited === 1,
            content: commentData.content,
            replyCount: commentData.reply_count,
            user: commentData.user,
            attachments: commentData.attachments || [],
            createdAt: commentData.created_at,
            immediateRepliesCount: commentData.immediate_replies_count,
        };
    }
    getStore(key) {
        const found = this.topicStores.find(s => s.key === key);
        return found ? found.store : null;
    }
    getDataStore() {
        return this.dataStore;
    }
    async postComment(payload) {
        const response = await this.API_CLIENT.post(`/${payload.threadId}/comments`, {
            parent_comment_id: payload.parentCommentId || null,
            ...payload,
        });
        return response.data.data;
    }
    async updateComment(payload) {
        const response = await this.API_CLIENT.put(`/${payload.threadId}/comments/${payload.id}`, payload);
        return response.data.data;
    }
    async deleteComment(payload) {
        const res = await this.API_CLIENT.delete(`/${payload.threadId}/comments/${payload.id}`);
        return res.data;
    }
    async createThreadWithComment(payload) {
        const response = await this.API_CLIENT.post(`/create-with-comment`, {
            ...payload,
            url: this.sourceUrl,
        });
        return response.data.thread;
    }
    async updateThread(payload) {
        try {
            const response = await this.API_CLIENT.put(`/${payload.threadId}`, {
                is_pinned: payload.isPinned,
                is_resolved: payload.isResolved,
                title: payload.title,
            });
            return response.data.thread;
        }
        catch (error) {
            throw new Error('Failed to update thread');
        }
    }
    async deleteThread(threadId) {
        try {
            await this.API_CLIENT.delete(`/${threadId}`);
        }
        catch (error) {
            throw new Error('Failed to delete thread');
        }
    }
    async deleteAllThreads(payload) {
        try {
            await this.API_CLIENT.delete(`/delete-all`, {
                params: {
                    is_resolved: payload.isResolved ? 1 : 0,
                }
            });
        }
        catch (error) {
            throw new Error('Failed to delete all threads');
        }
    }
    setThreadsAndComments(threadsData, storeKey) {
        const store = this.getStore(storeKey);
        const dataStore = this.getDataStore();
        if (!store)
            throw new Error(`Store with key ${storeKey} not found`);
        const storeState = store.getState();
        const dataStoreState = dataStore.getState();
        const allThreadIds = threadsData.map(t => t.id);
        const allCommentIds = threadsData.flatMap(t => t.comments.map(c => c.id));
        storeState.setThreadIds(allThreadIds);
        storeState.setCommentIds(allCommentIds);
        threadsData.forEach(td => {
            const commentIds = td.comments.map(c => c.id);
            storeState.addMapThreadToComments(td.id, commentIds);
        });
        const threads = threadsData.map(td => this.get_thread_from_data(td));
        const comments = threadsData.flatMap(td => td.comments.map(cd => this.get_comment_from_data(cd)));
        dataStoreState.setThreads(threads);
        dataStoreState.setComments(comments);
        storeState.clearSurfaceCommentIds();
        const processSurfacedComments = (comments) => {
            comments.forEach(cd => {
                const surfacedComments = (cd.surfaced_comments ? cd.surfaced_comments : []).map(sc => sc.id);
                if (surfacedComments.length > 0) {
                    storeState.addSurfacedCommentIds(cd.id, surfacedComments);
                    processSurfacedComments(cd.surfaced_comments || []);
                    dataStoreState.setComments((cd.surfaced_comments || []).map(scd => this.get_comment_from_data(scd)));
                }
            });
        };
        threadsData.forEach(td => {
            processSurfacedComments(td.comments);
        });
    }
    setRepliesToComment(commentId, repliesData, storeKey) {
        const store = this.getStore(storeKey);
        const dataStore = this.getDataStore();
        if (!store)
            throw new Error(`Store with key ${storeKey} not found`);
        const storeState = store.getState();
        const dataStoreState = dataStore.getState();
        const replyIds = repliesData.map(r => r.id);
        storeState.addMapCommentToReplies(commentId, replyIds);
        const replies = repliesData.map(rd => this.get_comment_from_data(rd));
        dataStoreState.setComments(replies);
    }
    hideRepliesFromComment(commentId, storeKey) {
        const store = this.getStore(storeKey);
        if (!store)
            throw new Error(`Store with key ${storeKey} not found`);
        const storeState = store.getState();
        storeState.removeMapCommentToReplies(commentId);
    }
    postReplyToComment(commentId, replyData) {
        const dataStore = this.getDataStore();
        const dataStoreState = dataStore.getState();
        const reply = this.get_comment_from_data(replyData);
        dataStoreState.setComments([reply]);
        const parentComment = dataStoreState.comments.get(commentId);
        if (parentComment) {
            const updatedParent = { ...parentComment, replyCount: parentComment.replyCount + 1, immediateRepliesCount: parentComment.immediateRepliesCount + 1 };
            dataStoreState.setComments([updatedParent]);
        }
        this.emitEvent({ type: 'comment-reply-added', comment: reply, parentCommentId: commentId });
    }
    addThreadComment(threadId, commentData) {
        const dataStore = this.getDataStore();
        const dataStoreState = dataStore.getState();
        const comment = this.get_comment_from_data(commentData);
        dataStoreState.setComments([comment]);
        this.emitEvent({ type: 'comment-root-added', comment, threadId });
    }
    addThreadWithCommentToStore(threadData) {
        const dataStore = this.getDataStore();
        const dataStoreState = dataStore.getState();
        const thread = this.get_thread_from_data(threadData);
        dataStoreState.setThreads([thread]);
        const commentData = threadData.comments[0];
        const comment = this.get_comment_from_data(commentData);
        dataStoreState.setComments([comment]);
        this.emitEvent({ type: 'thread-created-with-comment', thread, comment });
    }
    deleteThreadFromStore(threadId) {
        this.emitEvent({ type: 'thread-deleted', threadId: threadId });
    }
    deleteAllThreadsFromStore(isResolved) {
        this.dataStore.getState().threads.forEach((thread) => {
            if (thread.isResolved === isResolved)
                this.emitEvent({ type: 'thread-deleted', threadId: thread.id });
        });
    }
    deleteCommentFromStore(commentId) {
        const dataStore = this.getDataStore();
        const dataStoreState = dataStore.getState();
        const existingComment = dataStoreState.comments.get(commentId);
        if (existingComment) {
            const deletedComment = { ...existingComment, attachments: [], isDeleted: true };
            dataStoreState.setComments([deletedComment]);
        }
    }
    updateCommentInStore(commentId, commentData) {
        const dataStore = this.getDataStore();
        const dataStoreState = dataStore.getState();
        const updatedComment = this.get_comment_from_data(commentData);
        dataStoreState.setComments([updatedComment]);
    }
    updateThreadInStore(threadData) {
        const dataStore = this.getDataStore();
        const dataStoreState = dataStore.getState();
        const updatedThread = this.get_thread_from_data(threadData);
        dataStoreState.setThreads([updatedThread]);
        this.emitEvent({ type: 'thread-updated', thread: updatedThread });
    }
    emitEvent(event) {
        this.topicStores.forEach(({ store }) => {
            const storeState = store.getState();
            if (event.type === 'comment-reply-added') {
                const comment = event.comment;
                const parentCommentId = Number(event.parentCommentId);
                storeState.addSurfacedCommentIds(parentCommentId, [comment.id]);
            }
            if (event.type === 'comment-root-added') {
                const comment = event.comment;
                const threadId = Number(event.threadId);
                storeState.addMapThreadToComments(threadId, [comment.id]);
            }
            if (event.type === 'thread-created-with-comment') {
                const thread = event.thread;
                storeState.addThreadIds([Number(thread.id)]);
                const comment = event.comment;
                storeState.addMapThreadToComments(thread.id, [Number(comment.id)]);
            }
            if (event.type === 'thread-deleted') {
                const threadId = Number(event.threadId);
                storeState.deleteThreadIds([threadId]);
                storeState.removeMapThreadToComments(threadId);
            }
            if (event.type === 'thread-updated') {
                const thread = event.thread;
                storeState.addThreadIds([Number(thread.id)]);
            }
            if (event.type === 'thread-deleted-all') {
            }
        });
    }
    currentCreateThreadEvent = null;
    createThreadListener = null;
    subscribeToCreateThread(callback) {
        this.createThreadListener = callback;
        if (this.currentCreateThreadEvent) {
            callback(this.currentCreateThreadEvent);
        }
        return () => {
            this.createThreadListener = null;
        };
    }
    async createFloatingThread(props) {
        if (this.currentCreateThreadEvent) {
            this.closeCreateThread();
        }
        const { selector, attachTo, title } = props;
        if (!attachTo) {
            throw new Error("attachTo is required to create a floating thread");
        }
        const selectedElement = selector ? document.querySelector(selector) : null;
        if (!selectedElement) {
            throw new Error("Selector did not return any element.");
        }
        const attachedElement = attachTo instanceof HTMLElement ? attachTo : null;
        if (!attachedElement) {
            throw new Error("attachTo must be an HTMLElement");
        }
        const event = {
            attachedTo: attachedElement,
            title,
            selector: selector || ''
        };
        this.currentCreateThreadEvent = event;
        this.createThreadListener?.(event);
    }
    closeCreateThread() {
        this.currentCreateThreadEvent = null;
        this.createThreadListener?.(null);
    }
    constructor({ apiUrl = `${constants_1.BASE_URL}api/threads`, sourceUrl = '', namespace = '', panelContainer, panelTrigger, currentUser, isNamespaceAdmin = false, canManageThreads = false, initialThreadId, onCheck = () => true, onTravel = async () => { }, }) {
        if (!panelContainer) {
            throw new Error("Container element is required to display threads");
        }
        this.currentUser = currentUser;
        this.namespace = namespace;
        this.sourceUrl = sourceUrl;
        this.initialThreadId = initialThreadId;
        this.panelContainer = panelContainer;
        this.panelTrigger = panelTrigger;
        this.onCheck = onCheck;
        this.onTravel = onTravel;
        this.canManageThreads = canManageThreads;
        this.isNamespaceAdmin = isNamespaceAdmin;
        this.API_CLIENT = axios_1.default.create({
            baseURL: `${apiUrl}/${this.namespace}`,
            headers: {
                ...(window.HEADER_OBJ || {})
            }
        });
        (0, client_1.createRoot)(this.panelContainer).render(react_1.default.createElement(Threads_1.default, { topicsInstance: this }));
        this.goToInitialThread();
        this.initializePusherRealTimeUpdates();
    }
    initializePusherRealTimeUpdates() {
        if (!Topics.TOPICS_PUSHER_INSTANCE)
            return;
        this.API_CLIENT.interceptors.request.use(config => {
            const socketId = Topics.TOPICS_PUSHER_INSTANCE?.connection.socket_id;
            if (socketId) {
                config.headers['X-Socket-ID'] = socketId;
            }
            return config;
        }, error => {
            return Promise.reject(error);
        });
        const channel = Topics.TOPICS_PUSHER_INSTANCE.subscribe('private-topics-update.' + this.namespace);
        channel.bind('topics.realtime.update', (data) => {
            if (data.modelType === 'thread') {
                const actionHandler = this.threadActions[data.action];
                if (actionHandler) {
                    actionHandler(data.data);
                }
                else {
                    console.warn('Unknown action type for thread real-time update: ', data);
                }
            }
            else if (data.modelType === 'comment') {
                const actionHandler = this.commentActions[data.action];
                if (actionHandler) {
                    actionHandler(data.data);
                }
                else {
                    console.warn('Unknown action type for comment real-time update: ', data);
                }
            }
            else {
                console.warn('Unknown model type for real-time update:', data.modelType);
            }
        });
    }
    static INITIALIZE_PUSHER() {
        try {
            const pusherKey = process.env.MIX_PUSHER_APP_KEY;
            const pusherCluster = process.env.MIX_PUSHER_APP_CLUSTER;
            if (!pusherKey) {
                console.warn('Pusher key not found. Real-time notifications disabled.');
                return;
            }
            this.TOPICS_PUSHER_INSTANCE = new pusher_js_1.default(pusherKey, {
                cluster: pusherCluster,
                authEndpoint: `${constants_1.BASE_URL}broadcasting/auth`,
                auth: {
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }
            });
            Topics.INITIALIZE_PUSHER_USER_NOTIFICATIONS();
        }
        catch (error) {
            console.error('Failed to initialize Pusher:', error);
        }
    }
    static INITIALIZE_PUSHER_USER_NOTIFICATIONS() {
        if (!Topics.TOPICS_PUSHER_INSTANCE)
            return;
        const userId = document.querySelector('meta[name="auth-user"]')?.getAttribute('content');
        if (!userId) {
            console.warn("Auth user meta tag not found. User-specific notifications for Topics is disabled.");
            return;
        }
        Topics.TOPICS_USER_NOTIFICATIONS_CHANNEL = Topics.TOPICS_PUSHER_INSTANCE.subscribe(`private-topics-user.${userId}`);
        Topics.TOPICS_USER_NOTIFICATIONS_CHANNEL.bind('topics.user.notifications', (data) => {
            (0, NotificationToast_1.showCommentNotificationToast)(data);
        });
    }
    async goToInitialThread() {
        if (!this.initialThreadId)
            return;
        const loadPromise = new Promise((resolve, reject) => {
            document.addEventListener("DOMContentLoaded", async () => {
                let thread;
                try {
                    const res = await this.API_CLIENT.get(`/${this.initialThreadId}`);
                    thread = res.data;
                    if (!thread || !thread.id)
                        throw new Error("Invalid thread");
                }
                catch (err) {
                    return reject(new Error("Error loading thread"));
                }
                const activeTab = thread.is_resolved ? "resolved" : "unresolved";
                const observer = new MutationObserver((mutations) => {
                    for (const mutation of mutations) {
                        if (this.panelContainer.isConnected) {
                            setTimeout(() => {
                                this.panelContainer.querySelector(`[data-tab="${activeTab}"]`)?.click();
                            }, 500);
                        }
                        if (mutation.type === "childList" && this.panelContainer.isConnected) {
                            const threadEl = this.panelContainer.querySelector(`[data-thread-id="${thread.id}"]`);
                            if (threadEl) {
                                gsap.to(this.panelContainer.querySelector(".threads"), {
                                    scrollTo: threadEl,
                                    duration: 0.5,
                                    ease: "power2.inOut",
                                    onComplete: () => {
                                        (0, utils_1.highlightElement)(threadEl);
                                    },
                                });
                                resolve();
                                observer.disconnect();
                                break;
                            }
                        }
                    }
                });
                observer.observe(document.body, { childList: true, subtree: true });
                setTimeout(() => {
                    this.panelTrigger.click();
                }, 200);
            });
        });
        await window.toast.promise(loadPromise, {
            loading: "Going to thread",
            success: "Thread loaded successfully",
            error: (err) => err.message || "Failed to load thread",
        });
    }
}
exports.default = Topics;
Topics.INITIALIZE_PUSHER();
